import { VStack, Box, Text } from "@chakra-ui/react";
import { useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import { useSelector, useDispatch } from "react-redux";
import TextAreaInput from "../../components/forms/TextAreaInput";
import { useEffect, useState } from "react";
import FooterPmsSearch from "../../navigation/footer/FooterPmsSearch";

import SearchFormHeader from "../../practitioner-search/SearchFormHeader";
import {
  incrementPmsSearchStep,
  decrementPmsSearchStep,
} from "../../redux/actions/layout";
import { updatePmsSearchDetails } from "../../redux/actions/pmsSearch";

import PMSNavButtons from "./PMSNavButtons";

const PmsSearchSymptomDetails = () => {
  const pmsSearch = useSelector((state) => state.pmsSearch);

  const dispatch = useDispatch();
  const formContactDetails = useRef();
  const [direction, setDirection] = useState(null);

  //integrate form with redux
  const [hasLoaded, setHasLoaded] = useState(false);
  useEffect(() => {
    setHasLoaded(true);
  }, [pmsSearch]);

  // Footer navigation
  const handleClickPrev = () => {
    dispatch(decrementPmsSearchStep());
  };

  const handleClickNext = () => {
    setDirection("next");
    formContactDetails.current.handleSubmit();
  };

  // Wait for state to load
  if (!hasLoaded) return null;

  // Render
  return (
    <Formik
      innerRef={formContactDetails}
      initialValues={{
        symptoms: pmsSearch.symptoms,
      }}
      validationSchema={Yup.object({
        symptoms: Yup.string().required("Please fill in this field"),
      })}
      onSubmit={(values) => {
        dispatch(updatePmsSearchDetails(values));
        direction === "next"
          ? dispatch(incrementPmsSearchStep())
          : dispatch(decrementPmsSearchStep());
      }}
    >
      {(formik) => (
        <>
          <Box width="100%" maxW="container.sm" mx="auto" mb="120px" pt="24px">
            <SearchFormHeader />
            <VStack
              as="form"
              maxW="full"
              py={7}
              px={5}
              //mx="auto"
              spacing={8}
              alignItems="flex-start"
              bg="white"
              borderRadius={{ base: 0, md: 20 }}
              onSubmit={formik.handleSubmit}
              boxShadow="lg"
              overflow="hidden"
            >
              <Text textStyle="body2" color="brand.200">
                Please describe the main issues that you are seeking help with,
                along with any background details you feel are relevant. It can
                be helpful to include: your concerns and how long you&apos;ve
                been struggling with them, whether you have any specific goals
                for therapy, and whether you&apos;ve had any previous
                experiences of therapy that inform what you want from your
                sessions now.
              </Text>

              <TextAreaInput
                bg="brand.100"
                width="100%"
                name="symptoms"
                formlabel=""
                height="600px"
                placeholder="Start typing..."
              />
              <PMSNavButtons
                handleClickNext={handleClickNext}
                handleClickPrev={handleClickPrev}
              />
              <FooterPmsSearch
                handleClickNext={handleClickNext}
                handleClickPrev={handleClickPrev}
              />
            </VStack>
          </Box>
          {/* Footer */}
        </>
      )}
    </Formik>
  );
};

export default PmsSearchSymptomDetails;
